// extracted by css-extract-rspack-plugin
export default {"appBar":"appBar-LsJM0h","positionFixed":"positionFixed-jAoOEj","positionStatic":"positionStatic-Og7_5v","positionSticky":"positionSticky-QD7RpI"};